import React, {Component} from 'react'
import {Button, Card, Icon, Spin} from 'antd'
import TableHeader from "./table/TableHeader"
import TableBody from "./table/TableBody"
import ExportModal from "./ExportModal"
import {batchesStatistics} from "../../../services/api/3dApi"

class DashboardPage extends Component {
    state = {
        data: null,
        error: '',
        loading: false,
        openModal: false
    }

    componentDidMount() {
        this._getStatistic()
    }

    _getStatistic = async () => {
        try {
            this.setState({
                loading: true,
                error: ''
            })

            const {data: response} = await batchesStatistics()
            const {data, success, error} = response

            if (!success) {
                return this.setState({
                    error: error,
                    loading: false
                })
            }

            this.setState({
                data: data,
                loading: false
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _onOpenExport = () => {
        this.setState({
            openModal: true
        })
    }

    _onCloseExport = () => {
        this.setState({
            openModal: false
        })
    }

    render() {
        const {data, error, loading, openModal} = this.state

        return (
            <div className="OverTime p-3">
                <Card
                    className="m-3 ProductionProgress"
                    title="Thống kê tiến độ sản xuất"
                    extra={<Icon type="bar-chart"/>}
                >
                    <Spin tip="Loading..." spinning={loading}>
                        {
                            data !== null && (
                                <>
                                    <Button
                                        type='primary'
                                        icon='export'
                                        className='float-right mb-3 ButtonCustom'
                                        onClick={this._onOpenExport}
                                    >
                                        Export
                                    </Button>
                                    <table className="table tableProductionProgress">
                                        <TableHeader/>
                                        <TableBody data={data}/>
                                    </table>
                                </>
                            )
                        }

                        {
                            (data === null && !error) && (
                                <div className="font-18">Không có dữ liệu</div>
                            )
                        }

                        {
                            error && (
                                <div className="text-danger font-18">{error}</div>
                            )
                        }
                    </Spin>
                </Card>

                <ExportModal openModal={openModal} onCloseModal={this._onCloseExport}/>
            </div>
        )
    }

}

export default DashboardPage
